import { render } from "./IdnPdf.vue?vue&type=template&id=8b418256&scoped=true"
import script from "./IdnPdf.vue?vue&type=script&lang=js"
export * from "./IdnPdf.vue?vue&type=script&lang=js"

import "./IdnPdf.vue?vue&type=style&index=0&id=8b418256&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b418256"]])

export default __exports__